import * as React from "react";
import Popup from "../components/popup";
import CssLoader from "../components/CssLoader";
import {pageFilter} from "../data/page_data";
import {navigate} from "@reach/router";
import axios from "axios";
import {Button} from 'reactstrap';
import * as ReactGA from "react-ga";
import {isIOS} from "react-device-detect";
import FloatingButton from "../components/FloatingButton";

export default class JoinPage extends React.Component {
  inputValue = "";
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      value: "",
      result: false,
      message: "",
      hasok: false
    };
    this.pageData = pageFilter(this.props.artist, "../");
  }

  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  register = () => {
    console.log("register");
  };

  togglepopup = () => {
    this.setState({ modal: !this.state.modal });
  };

  go = () => {
    navigate("home");
  };

  handleChange = (event) =>{
    this.inputValue = event.target.value;
  }

  redeem = () => {
    console.log('Kode', this.inputValue);
    axios
      .get(
        "/w/api/" +
        this.pageData.artist.id +
          "/redeem?code=" +
          encodeURIComponent(this.inputValue)
      )
      .then((response) => {
        const data = response.data;
        console.log(data);
        this.setState({ result: data.result, message: data.message });
        this.togglepopup();
      });
  };

  clickSms = (link)=>{
    if(link.startsWith('sms:')){
      if(isIOS){
        window.location.href = link.replace('&', '');
      }else{
        window.location.href = link;
      }
    }else{
      window.location.href = link;
    }
  }

  render() {
    console.log(this.pageData.artist.sms);
    return (
      <React.Fragment>
        <CssLoader css={this.pageData.artist.css} />
        {this.pageData.artist.floating_url && (
            <FloatingButton url={this.pageData.artist.floating_url} />
        )}
        <div>
          <div
            className="join-wrapper"
            style={{ backgroundImage: `url(${this.pageData.artist.join_bg})`}}
          >
            <Button color="none" className="btn-close-join" onClick={this.go}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M24,3.977,20.023,0,12,8.023,3.977,0,0,3.977,8.023,12,0,20.023,3.977,24,12,15.977,20.023,24,24,20.023,15.977,12Z" />
          </svg>
          </Button>
            <div className="join">
              <div className="join-inner">
                <h5>Pilih operator kamu untuk bergabung!</h5>
                <ul>
                  {this.pageData.artist.sms.tsel ? (
                    <li>
                      <a href={this.pageData.artist.sms.tsel} className="btn">
                        <img src="http://resources.triyakom.com/mini_portal/join/tsel.png" />
                      </a>
                    </li>
                  ) : (
                    <></>
                  )}
                  {this.pageData.artist.sms.im3 ? (
                    <li>
                      <a href={this.pageData.artist.sms.im3} className="btn">
                        <img src="http://resources.triyakom.com/mini_portal/join/isat.png" />
                      </a>
                    </li>
                  ) : (
                    <></>
                  )}
                  {this.pageData.artist.sms.xl ? (
                    <li>
                      <a href={this.pageData.artist.sms.xl} className="btn">
                        <img src="http://resources.triyakom.com/mini_portal/join/xl.png" />
                      </a>
                    </li>
                  ) : (
                    <></>
                  )}
                  {this.pageData.artist.sms.tri ? (
                    <li>
                      <a href={this.pageData.artist.sms.tri} className="btn">
                        <img src="http://resources.triyakom.com/mini_portal/join/hti.png" />
                      </a>
                    </li>
                  ) : (
                    <></>
                  )}
                  {this.pageData.artist.sms.sf ? (
                    <li>
                      <a href={this.pageData.artist.sms.sf} className="btn">
                        <img src="http://resources.triyakom.com/mini_portal/join/sf.png" />
                      </a>
                    </li>
                  ) : (
                    <></>
                  )}
                </ul>
                <h5>
                  Atau gunakan kode promo untuk mendapatkan keuntungan lainnya
                </h5>
                <div className="join-input">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Masukkan kode promo"
                    onChange={this.handleChange}
                  />
                  <button className="btn btn-redeem" onClick={this.redeem}>
                    REDEEM
                  </button>
                </div>
              </div>
            </div>
          </div>
          <Popup
          okfunc={this.state.result ? this.go : null}
          //okfunc={this.togglepopup}
            text={this.state.message}
            open={this.state.modal}
            toggle={this.togglepopup}
          />
        </div>
      </React.Fragment>
    );
  }
}
